<template>
  <div class="data-area">
    <h1>融资查询</h1>
    <br>
    <Row class="tac">
      <Col span="8">
        <span class="label">融资企业名称：</span>
        <Input placeholder="请输入融资企业名称" v-model="queryParams.cpName" class="input-select"></Input>
      </Col>
      <Col span="8">
        <span class="label">核心企业名称：</span>
        <Input placeholder="请输入核心企业名称" v-model="queryParams.coreName" class="input-select"></Input>
      </Col>
      <Col span="8">
        <span class="label">债权编号：</span>
        <Input placeholder="请输入债权编号" v-model="queryParams.pkCredit" class="input-select"></Input>
      </Col>
    </Row>
    <br>
    <Row class="tac">
      <Col span="8"> 
        <span class="label">融资申请日期：</span>
        <DatePicker :value="queryParams.applyTimeStart" type="date" format="yyyy-MM-dd" placeholder="开始" style="width:110px;" @on-change="setDateTime($event, 'applyTimeStart')" :options="disableTime(queryParams.applyTimeEnd,1)"></DatePicker><i class="zhi">-</i>
        <DatePicker :value="queryParams.applyTimeEnd" type="date" format="yyyy-MM-dd" placeholder="结束" style="width:110px;" @on-change="setDateTime($event, 'applyTimeEnd')" :options="disableTime(queryParams.applyTimeStart,2)"></DatePicker>
      </Col>
      <Col span="8">
        <span class="label">放款日期：</span>
        <DatePicker :value="queryParams.loanTimeStart" type="date" format="yyyy-MM-dd" placeholder="开始" style="width:110px;"  @on-change="setDateTime($event, 'loanTimeStart')" :options="disableTime(queryParams.loanTimeEnd,1)"></DatePicker><i class="zhi">-</i>
        <DatePicker :value="queryParams.loanTimeEnd" type="date" format="yyyy-MM-dd" placeholder="结束" style="width:110px;"  @on-change="setDateTime($event, 'loanTimeEnd')" :options="disableTime(queryParams.loanTimeStart,2)"></DatePicker>
      </Col>
      <Col span="8">
      </Col>
    </Row>
    <br>
    <Row class="tac">
      <Col span="24">
        <Button type="primary" @click="query(1);queryCount()">查询</Button>
        <Button class="ml20" @click="queryParams={};query(1);queryCount()">重置</Button>
      </Col>
    </Row>
    <Row>
      <Col span="20" class="tab-box">
        <!-- <span class="label">债权状态：</span> -->
        <Button :type="tagState === 'ALL' ? 'primary': 'text'" @click="changeTag('ALL')" class="line">
          <span>全部</span>
          <span class="pl-6" :class="{'c-f70': tagState !== 'ALL'}">{{count[0]}}</span>
        </Button>
        <Button :type="tagState === 'FINANCING_FINANCE' ? 'primary': 'text'" @click="changeTag('FINANCING_FINANCE')" class="line">
          <span>放款审核中</span>
          <span class="pl-6" :class="{'c-f70': tagState !== 'FINANCING_FINANCE'}">{{count[1]}}</span>
        </Button>
        <Button :type="tagState === 'FINANCED' ? 'primary': 'text'" @click="changeTag('FINANCED')">
          <span>已放款</span>
          <span class="pl-6" :class="{'c-f70': tagState !== 'FINANCED'}">{{count[2]}}</span>
        </Button>
      </Col>
      <Col span="4"></Col>
    </Row>
    <br>
    <Table stripe :columns="columns" :data="data" :loading="loading"></Table>
    <br>
    <Row>
      <Col span="8">
        <span>统计：</span>
        <span class="mr20">笔数 {{pagecond.count}}</span>
        <span class="mr20">债权金额 {{totalAmount[0] | currency}}元</span>
        <span>放款金额 {{totalAmount[1] | currency}}元</span>
      </Col>
      <Col span="16" class="tar">
        <Page :total="pagecond.count" :current="pagecond.page" :page-size="pagecond.pageSize" @on-change="changePage"
          @on-page-size-change="changePageSize" show-elevator show-total show-sizer size="small" placement="top">
        </Page>
      </Col>
    </Row>
  </div>
</template>
<script>
import Vue from  'vue'
import ajax from "@/libs/ajax"
import config from '@/config/index'
import { disableTimeInput, dateFormat } from '@/libs/util'
import downloadService from '@/libs/download-file'

export default {
  name: 'finance-finance-query',
  data() {
    return {
      queryParams: {
        applyTimeStart: '',
        applyTimeEnd: '',
        loanTimeStart: '',
        loanTimeEnd: ''
      },
      loading: false,
      columns: [
        {
          title: "序号",
          type: "index",
          width: 65,
          align: 'center'
        },
        {
          title: "债权编号",
          key: "pkCredit",
          render: (h, params) => {
            return h('div', {
              style:{
                color:'#2d8cf0',
                cursor:'pointer'
              },
              on: {
                click: () => {
                  this.$router.push({path: '/detail', query: {fkCredit: params.row.pkCredit}})
                }
              }
            },params.row.pkCredit);
          }
        },
        {
          title: "融资企业名称",
          key: "cpName"
        },
        {
          title: "核心企业名称",
          key: "coreName"
        },
        {
          title: "债权金额（元）",
          key: "creditAmount",
          render: (h, params) => {
            return h('div', Vue.filter('currency')(params.row.creditAmount));
          }
        },
        {
          title: "承诺付款日期",
          key: 'maturityDateString'
        },
        {
          title: "融资申请日期",
          key: "applyTimeString"
        },
        {
          title: "资金方利率 | 费率",
          render: (h, params) => {
            var iArr = [];
            iArr.push(
              h(
                "span",
                { style: { display: "block" } },
                params.row.financingRateString
              )
            );
            iArr.push(
              h(
                "span",
                { style: { display: "block" } },
                params.row.financeFeeRateString
              )
            );
            return h("p", iArr);
          }
        },
        {
          title: "放款日期 | 放款入账金额",
          render: (h, params) => {
            var iArr = [];
            iArr.push(
              h(
                "span",
                { style: { display: "block" } },
                params.row.loanTimeString
              )
            );
            iArr.push(
              h("span", { style: { display: "block" } }, params.row.loanAmount ? Vue.filter('currency')(params.row.loanAmount) : '')
            );
            return h("p", iArr);
          }
        },
        {
          title: '债权状态',
          render: (h, params) => {
            return h('div', this.creditStatusObj[params.row.creditStatus])
          }
        },
        {
          title: '操作',
          key: 'actions',
          width: 150,
          render: (h, params) => {
            var actionsButton = [];
            actionsButton.push(h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '2px'
              },
              on: {
                click: () => {
                  this.$router.push({path: '/detail', query: {fkCredit: params.row.pkCredit}})
                }
              }
            }, '详情'));
            actionsButton.push(h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '2px'
              },
              on: {
                click: () => {
                  this.downloadFiles(params.row.pkCredit)
                }
              }
            }, '材料下载'));
            return h('div', actionsButton);
          }
        }
      ],
      data: [],
      pagecond: {
        count: 0,
        page: 1,
        pageSize: 10
      },
      tagState: 'ALL',
      count: [],
      totalAmount: [],
      creditStatusObj: window.CCBSCF_ENUM_OBJ.CREDIT_STATE
    };
  },
  created() {
    this.queryParams.applyTimeStart = dateFormat(new Date().getTime() - 6*24*60*60*1000, 'yyyy-MM-dd')
    this.queryParams.applyTimeEnd = dateFormat(new Date(), 'yyyy-MM-dd')
    this.query();
    this.queryCount()
  },
  methods: {
    changePage(v) {
      this.pagecond.page = v;
      this.query();
    },
    changePageSize(v) {
      this.pagecond.pageSize = v;
      if (this.pagecond.page === 1) {
        this.query(1)        
      }
    },
    query(page) {
      this.loading = true;
      let params = {
        page: page || this.pagecond.page,
        pageSize: this.pagecond.pageSize,
        ...this.queryParams
      }
      if (this.tagState !== 'ALL') {
        params.creditStatus = this.tagState
      }
      ajax.get('/fin/v1/credits/list', {
        params: params
      }).then((res) => {
        this.loading = false;
        if (res.code == 0) {
          this.data = res.data.datalist;
          this.pagecond = res.data.pagecond;
          this.totalAmount = res.data.grandTotal
        } else {
          this.$Tip.warning({
            content: res.message
          })
        }
      }).catch(err => {
        this.loading = false;
        this.$Tip.error({
          content: err.message
        })
      });
    },
    queryCount () {
      ajax.get('/fin/v1/credits/list/counts').then((res) => {
        if (res.code == 0) {
          this.count = res.data || []
        } else {
          this.$Tip.warning({
            content: res.message
          })
        }
      })
    },
    // 切换债权tab
    changeTag (tag) {
      this.tagState = tag;
      this.pagecond = {
        count: 0,
        page: 1,
        pageSize: 10
      }
      this.query();
      this.queryCount();
    },
    setDateTime (v, key) {
      this.queryParams[key] = v
    },
    disableTime (time, type) {
      return disableTimeInput(time, type)
    },
    // 下载文件包
    downloadFiles (pkCredit) {
      downloadService.saveFile(config.baseUrl + '/fin/v1/credits/finance/docs/download', {
        pkCredit: pkCredit
      })
    }
  }
}; 
</script>
<style lang="less" scoped>
.c-f70 {
  color: #f70;
}
.line:after {
  content: "";
  position: relative;
  top: 0;
  left: 18px;
  width: 0;
  height: 20px;
  border-right: 1px solid #dddee1;
}
.right{
  text-align: right;
}
.pl-6 {
  padding-left: 6px;
}
</style>
